import {
	ADMINGETKYCPROOFLIST_SUCCESS,
	ADMINGETKYCPROOFLIST_FAILED,
	RESET_ADMINGETKYCPROOFLIST,
	LOADING_ADMINGETKYCPROOFLIST,
	NETWORK_ERROR_ADMINGETKYCPROOFLIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETKYCPROOFLIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETKYCPROOFLIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETKYCPROOFLIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETKYCPROOFLIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETKYCPROOFLIST:
			return (state = initialState);
		default:
			return state;
	}
};
